<mat-card class="mb-3">
  <mat-card-header>
    <mat-card-title>Indstillinger</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div fxLayout="column">
      <p>Opsætninger, som ikke er knyttet til et specifikt modul.</p>
      <mat-form-field class="mt-2">
        <mat-label>Søg efter indstilling</mat-label>
        <input type="text" name="search"
               [formControl]="searchControl"
               matInput>
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
    </div>
  </mat-card-content>
</mat-card>

@if (filteredSettings$ | async; as filteredSettings) {
  <mat-accordion>
    <!-- Generelt & Administration -->
    @if (hasVisibleSettingsInCategory('Generelt & Administration', filteredSettings)) {
      <div class="category-header mt-3 mb-2">
        <h3 class="mat-h3 mb-0">Generelt & Administration</h3>
        <mat-divider></mat-divider>
      </div>
    }

    @if (isVisible('journal_no', filteredSettings)) {
      <app-journal-no-settings [@fadeIn] [@fadeOut]
        [settings]="customer.settings.journal_no"
        (saveSettings)="save('journal_no', $event)"
      ></app-journal-no-settings>
    }

    @if (isVisible('profile', filteredSettings)) {
      <app-profile-settings [@fadeIn] [@fadeOut]
        [settings]="customer.settings.profile"
        [nemKontoEnabled]="customer.wealth_manager.nem_konto"
        (saveSettings)="save('profile', $event)"
      ></app-profile-settings>
    }

    @if (isVisible('case-workers', filteredSettings)) {
      <app-case-worker-settings [@fadeIn] [@fadeOut]
        [settings]="customer.settings['case-workers']"
        (saveSettings)="save('case-workers', $event)"
      ></app-case-worker-settings>
    }

    @if (isVisible('custom-value', filteredSettings)) {
      <app-custom-value-settings [@fadeIn] [@fadeOut]
        [settings]="customer.settings['custom-value']"
        (saveSettings)="save('custom-value', $event)"
      ></app-custom-value-settings>
    }

    @if (isVisible('history', filteredSettings)) {
      <app-history-settings [@fadeIn] [@fadeOut]
        [settings]="customer.settings.applicant"
        (saveSettings)="save('applicant', $event)"
      ></app-history-settings>
    }

    <!-- Kommunikation & Support -->
    @if (hasVisibleSettingsInCategory('Kommunikation & Support', filteredSettings)) {
      <div class="category-header mt-3 mb-2">
        <h3 class="mat-h3 mb-0">Kommunikation & Support</h3>
        <mat-divider></mat-divider>
      </div>
    }

    @if (isVisible('dialog', filteredSettings)) {
      <app-dialog-settings [@fadeIn] [@fadeOut]
      ></app-dialog-settings>
    }

    @if (isVisible('comments', filteredSettings)) {
      <app-comments-settings [@fadeIn] [@fadeOut]
        [settings]="customer.settings.comments"
        (saveSettings)="save('comments', $event)"
      ></app-comments-settings>
    }

    @if (isVisible('sms', filteredSettings)) {
      <app-sms-settings [@fadeIn] [@fadeOut]
        [settings]="customer.settings.sms"
        (saveSettings)="save('sms', $event)"
      ></app-sms-settings>
    }

    @if (isVisible('smtp', filteredSettings)) {
      <app-smtp-settings [@fadeIn] [@fadeOut]
        [settings]="customer.settings.smtp"
        (saveSettings)="save('smtp', $event)"
      ></app-smtp-settings>
    }

    @if (isVisible('support', filteredSettings)) {
      <app-support-settings [@fadeIn] [@fadeOut]
        [settings]="customer.settings.support"
        (saveSettings)="save('support', $event)"
      ></app-support-settings>
    }

    <!-- Økonomi & Jura -->
    @if (hasVisibleSettingsInCategory('Økonomi & Jura', filteredSettings)) {
      <div class="category-header mt-3 mb-2">
        <h3 class="mat-h3 mb-0">Økonomi & Jura</h3>
        <mat-divider></mat-divider>
      </div>
    }

    @if (isVisible('payments', filteredSettings)) {
      <app-payments-settings [@fadeIn] [@fadeOut]
        [settings]="customer.settings.payments"
        (saveSettings)="save('payments', $event)"
      ></app-payments-settings>
    }

    @if (isVisible('accounting', filteredSettings)) {
      <app-accounting-settings [@fadeIn] [@fadeOut]
        [settings]="customer.settings.accounting"
        (saveSettings)="save('accounting', $event)"
      ></app-accounting-settings>
    }

    @if (isVisible('gdpr', filteredSettings)) {
      <app-gdpr-settings [@fadeIn] [@fadeOut]
        [settings]="customer.settings.gdpr"
        (saveSettings)="save('gdpr', $event)"
      ></app-gdpr-settings>
    }

    <!-- Sikkerhed & Adgang -->
    @if (hasVisibleSettingsInCategory('Sikkerhed & Adgang', filteredSettings)) {
      <div class="category-header mt-3 mb-2">
        <h3 class="mat-h3 mb-0">Sikkerhed & Adgang</h3>
        <mat-divider></mat-divider>
      </div>
    }

    @if (isVisible('authentication', filteredSettings)) {
      <app-authentication-settings [@fadeIn] [@fadeOut]
        [settings]="customer.settings.authentication"
        (saveSettings)="save('authentication', $event)"
      ></app-authentication-settings>
    }

    @if (isVisible('security', filteredSettings)) {
      <app-security-settings [@fadeIn] [@fadeOut]
        [settings]="customer.settings.security"
        (saveSettings)="save('security', $event)"
      ></app-security-settings>
    }

    @if (isVisible('export_project_logs', filteredSettings)) {
      <app-export-project-logs-settings [@fadeIn] [@fadeOut]
        [settings]="customer.settings.export_project_logs"
        (saveSettings)="save('export_project_logs', $event)"
      ></app-export-project-logs-settings>
    }

    <!-- Data & Rapportering -->
    @if (hasVisibleSettingsInCategory('Data & Rapportering', filteredSettings)) {
      <div class="category-header mt-3 mb-2">
        <h3 class="mat-h3 mb-0">Data & Rapportering</h3>
        <mat-divider></mat-divider>
      </div>
    }

    @if (isVisible('overview_xlsx', filteredSettings)) {
      <app-overview-xlsx-settings [@fadeIn] [@fadeOut]
        [settings]="customer.settings.overview_xlsx"
        (saveSettings)="save('overview_xlsx', $event)"
      ></app-overview-xlsx-settings>
    }

    @if (isVisible('import', filteredSettings)) {
      <app-import-settings [@fadeIn] [@fadeOut]
        [settings]="customer.settings.import"
        (saveSettings)="save('import', $event)"
      ></app-import-settings>
    }

    @if (isVisible('materialized_view', filteredSettings)) {
      <app-materialized-view-settings [@fadeIn] [@fadeOut]
        [settings]="customer.settings.materialized_view"
        (saveSettings)="save('materialized_view', $event)"
      ></app-materialized-view-settings>
    }

    @if (isVisible('extra-columns', filteredSettings)) {
      <app-extra-columns-settings [@fadeIn] [@fadeOut]
      ></app-extra-columns-settings>
    }

    <!-- Specialiserede funktioner -->
    @if (hasVisibleSettingsInCategory('Specialiserede funktioner', filteredSettings)) {
      <div class="category-header mt-3 mb-2">
        <h3 class="mat-h3 mb-0">Specialiserede funktioner</h3>
        <mat-divider></mat-divider>
      </div>
    }

    @if (isVisible('votes', filteredSettings)) {
      <app-votes-settings [@fadeIn] [@fadeOut] [settings]="customer.settings.votes"
                          (saveSettings)="save('votes', $event)"></app-votes-settings>
    }

    @if (isVisible('siblings', filteredSettings)) {
      <app-siblings-settings [@fadeIn] [@fadeOut]></app-siblings-settings>
    }

    @if (isVisible('warnings', filteredSettings)) {
      <app-warnings-settings [@fadeIn] [@fadeOut]
        [settings]="customer.settings.warnings"
        (saveSettings)="save('warnings', $event)"
      ></app-warnings-settings>
    }
  </mat-accordion>
}
